import { useCallback, useRef, useState } from 'react'
import { Button, Modal } from 'antd'
import { CameraOutlined, CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import Webcam from 'react-webcam'

const CaptureImage = ({
  disabled = false,
  onCapture = () => {}
}) => {
  const [ show, setShow ] = useState(false)
  const [ facingMode, setFacingMode ] = useState('environment')
  
  const webcamRef = useRef(null)

  function handleToggleCamera() {
    setFacingMode(prev =>
      prev === 'user' ? 'environment' : 'user'
    )
  }

  const Camera = useCallback(() => {
    const videoConstraints = {
      facingMode: facingMode === 'user' ? 'user' : { exact: 'environment' }
    }

    return (
      <Webcam
        audio={false}
        forceScreenshotSourceSize={true}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        screenshotQuality={1}
        width="100%"
        videoConstraints={videoConstraints}
      />
    )
  }, [facingMode, webcamRef])

  function handleCaptureImage() {
    const imageSrc = webcamRef.current?.getScreenshot()

    onCapture(imageSrc)
    setShow(false)
  }

  function handleCancel() {
    setShow(false)
  }
 
  return (
    <>
      <Modal
        closable={false}
        destroyOnClose
        okText="Capture Image"
        open={show}
        onCancel={handleCancel}
        onOk={handleCaptureImage}
        footer={[
          <Button
            className="camera-toggle-button"
            icon={facingMode === 'user' ? <CaretUpOutlined /> : <CaretDownOutlined />}
            key="toggle-view"
            onClick={handleToggleCamera}
          >
            {facingMode === 'user' ? 'Rear Camera (Outwards)' : 'Front Camera (Face)'}
          </Button>,
          <Button
            className="camera-cancel-button"
            key="cancel"
            type="secondary"
            onClick={handleCancel}
          >
            Cancel
          </Button>,
          <Button 
            key="capture"
            type="primary"
            onClick={handleCaptureImage}>
              Capture Image
          </Button>
        ]}
      >
        <Camera />
      </Modal>
      <Button
        className="camera-button"
        disabled={disabled}
        icon={<CameraOutlined />}
        onClick={() => setShow(true)}
      >
        Photo
      </Button>
    </>
  )
}

export default CaptureImage
